export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <rect x="76" y="76" width="104" height="104" fill={fill} />
  </>
);
